import { UserOutlined } from "@ant-design/icons";
import { Trans } from "@lingui/macro";
import { Alert, Tag } from "antd";
import React from "react";
import CountIconBadge from "bukku/components/Select/Contacts/CountIconBadge";

const CONTACT_GROUP_PROCESS_LABELS = {
  post_dating: <Trans>Post Dating</Trans>,
  batch_processing: <Trans>Batch Processing</Trans>,
  contact_group: <Trans>Contact Group</Trans>,
} as Record<string, React.ReactNode>;

export function getUnprocessableFields({
  can_process,
  group_name,
}: {
  can_process: Record<string, boolean>;
  group_name?: string;
}) {
  return Object.entries(can_process)
    .filter(([_, value]) => !value)
    .map(([key]) => (
      <li key={key}>
        {CONTACT_GROUP_PROCESS_LABELS[key] || key}
        {Boolean(!!group_name && key === "contact_group") && (
          <>
            &nbsp;&nbsp;
            <Tag color="geekblue" style={{ padding: "0 2px" }}>
              {group_name}&nbsp;&nbsp;
              <UserOutlined />
            </Tag>
          </>
        )}
      </li>
    ));
}

export default function InstructionUnprocessableAlert({
  can_process = {},
  group_name,
}: {
  can_process: Record<string, boolean>;
  group_name: string;
}) {
  const unprocessableFieldsListItem = getUnprocessableFields({
    can_process,
    group_name,
  });

  if (unprocessableFieldsListItem.length === 0) {
    return null;
  }

  return (
    <Alert
      type="warning"
      showIcon
      message={
        <strong>
          <Trans>This instruction cannot be processed</Trans>
        </strong>
      }
      description={
        <div>
          <Trans>
            <strong><Trans>Contact Group</Trans></strong> feature is required for the following fields:
          </Trans>
          <ul className="ul__disc font-size-14 with-padding-start">
            {unprocessableFieldsListItem}
          </ul>
          <br />
          <Trans>Please upgrade your plan or contact support</Trans>
        </div>
      }
      style={{ marginBottom: 12 }}
    />
  );
}
